module.exports = __webpack_public_path__ + "img/logo.81eed0b7.png";